export const ADAPTER_PLAYER_KEYS = [
  "fill_in_the_text",
  "fill_in_blanks",
  "fill_in_the_blanks",
  "select_the_word",
  "multiple_choice",
  "MultipleChoice",
  "speak_the_sentence",
  "watch_large_video",
  "watch_video",
  "video",
  "watch_simple_video",
  "write_the_translation",
  "drag_and_drop",
  "audio_recording",
  "comprehension_question",
  "pronunciation_practice",
  "formatted_text",
  "styled_section",
  "glossary_display",
] as const;

export type AdapterType = (typeof ADAPTER_PLAYER_KEYS)[number];

export function isAdapterType(
  type: string,
  players: Record<string, unknown>
): type is AdapterType {
  return Object.prototype.hasOwnProperty.call(players, type);
}
